import { IRtcStream } from "@formant/core/model/IRtcStream";

import { encodeStreamId } from "./encodeStreamId";

export function streamIsEqual(stream1: IRtcStream, stream2: IRtcStream) {
    return encodeStreamId(stream1) === encodeStreamId(stream2);
}
